import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import ProductLinksLoader from './ProductLinksLoader';
import ProjectsHeaderTabs from './ProjectsHeaderTabs';
import ProjectsHeaderTitles from './ProjectsHeaderTitles';
import RemoteComponent from '../../components/RemoteComponent/RemoteComponent';
import { RemoteProjectList } from '../../envs/types';
import useRemotes from '../../hooks/useRemotes';

const ProjectsHeaderContainerWithoutFilters = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const ProjectsHeaderContainer = styled(ProjectsHeaderContainerWithoutFilters)({
  margin: '0 48px',
});

type ProjectsHeaderProps = {
  showUserHomeTab?: boolean;
  showUserHomeTabLoading?: boolean;
  showUpdatedProductLinksLayout?: boolean;
  showUpdatedProductLinksLayoutLoading?: boolean;
};

const ProjectsHeader: FC<ProjectsHeaderProps> = ({
  showUserHomeTab,
  showUserHomeTabLoading,
  showUpdatedProductLinksLayout,
  showUpdatedProductLinksLayoutLoading,
}) => {
  const remotes = useRemotes();
  const { value: showFiltersPanel } = useAlloyFeatureFlag('pl_filters_panel');

  const projectListRemote = remotes?.find(
    (r) => r.scope === 'accProjectList'
  ) as RemoteProjectList | undefined;

  const Container = showFiltersPanel
    ? ProjectsHeaderContainer
    : ProjectsHeaderContainerWithoutFilters;
  return (
    <>
      <Container>
        <ProjectsHeaderTitles
          showUserHomeTabLoading={showUserHomeTabLoading}
          showUserHomeTab={showUserHomeTab}
        />
        {!showUpdatedProductLinksLayout &&
        !showUpdatedProductLinksLayoutLoading &&
        projectListRemote ? (
          <RemoteComponent
            url={projectListRemote.url}
            scope={projectListRemote.scope}
            module={projectListRemote.modules.projectsHeaderLinksModule}
            renderLoader={() => <ProductLinksLoader />}
          />
        ) : null}
      </Container>
      {!showUserHomeTabLoading && (
        <ProjectsHeaderTabs showUserHomeTab={showUserHomeTab} />
      )}
    </>
  );
};

ProjectsHeader.propTypes = {
  showUserHomeTab: PropTypes.bool,
  showUserHomeTabLoading: PropTypes.bool,
  showUpdatedProductLinksLayout: PropTypes.bool,
  showUpdatedProductLinksLayoutLoading: PropTypes.bool,
};

export default ProjectsHeader;
